import { SEARCH_ERRORS } from "@search/api/constants";
import { type LocationsResponse } from "@search/api/types";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

import { MUTATION_OPTIONS, getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/locations`;

const searchLocations = getJSON<LocationsResponse>(
  SEARCH_ERRORS.GENERIC_ERROR,
  {
    transformUrl: (url: string, payload: { arg: { prefix: string } }) =>
      `${url}?prefix=${payload.arg}`,
  },
);

export const useLocationQuery = (
  onSuccess?: (results: LocationsResponse) => void,
) => {
  const { data } = useSWR(API_URL);

  const { trigger, error, isMutating } = useSWRMutation(
    API_URL,
    searchLocations,
    {
      ...MUTATION_OPTIONS,
      onSuccess,
    },
  );

  return {
    results: data?.data,
    searchLocations: trigger,
    locationsError: error || !!data?.errors.at(0),
    isSearchingLocations: isMutating,
  };
};
